/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditOfferServiceRequest } from '../../models/edit-offer-service-request';

export interface UpdateOfferService$Params {
  id: number;
  serviceId: number;
      body: EditOfferServiceRequest
}

export function updateOfferService(http: HttpClient, rootUrl: string, params: UpdateOfferService$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateOfferService.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('serviceId', params.serviceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateOfferService.PATH = '/offers/{id}/services/{serviceId}';
